export class FetchActivityCategories {
  static readonly type = '[ActivityCategories] - FetchActivityCategories';
}
